import { app } from '@/main';
import { DayOffResource } from '@/resources/dayOff.resource';

/**
 * Serwis dni wolnych
 *
 * @export
 * @class DayOffService
 */
export class DayOffService {
  /**
   * Zapisuje dzień wolny
   *
   * @param {*} form
   * @param {number} userId
   * @param {number} absenceId
   * @param {number} id
   * @returns {Promise<any>}
   * @memberof DayOffService
   */
  public save(form: any, userId: number, absenceId: number, id: number): Promise<any> {
    return id ? this.updateDayOff(form, absenceId, id) : this.addDayOff(form, userId, absenceId);
  }
  /**
   * Dodaje dzień wolny
   *
   * @param {*} form
   * @param {number} userId
   * @param {number} absenceId
   * @returns {Promise<any>}
   * @memberof DayOffService
   */
  public async addDayOff(form: any, userId: number, absenceId: number): Promise<any> {
    return DayOffResource.add(form, userId, absenceId).catch(error => {
      console.warn(error);
      app.$notify({ type: 'error', title: 'Błąd', text: 'Wystąpił błąd podczas dodawania dnia wolnego' });
    });
  }

  /**
   * Aktualizuje dzień wolny
   *
   * @param {*} form
   * @param {number} absenceId
   * @param {number} id
   * @returns {Promise<any>}
   * @memberof DayOffService
   */
  public updateDayOff(form: any, absenceId: number, id: number): Promise<any> {
    return DayOffResource.update(id, form, absenceId).catch(error => {
      console.warn(error);
      app.$notify({ type: 'error', title: 'Błąd', text: 'Wystąpił błąd podczas aktualizacji dnia wolnego' });
    });
  }
}

export const dayOffService = new DayOffService();
